import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Training} from '../models/training';
import {TrainingService} from '../services/training.service';
import {first} from 'rxjs/operators';
import {TrainingItems} from '../models/trainingItems';
import {AlertService} from '../services';
import {Router} from '@angular/router';
import {TrainingDetailsModalComponent} from './trainingDetailsModal.component';

export interface TrainingListModalData {
    resourceId?: string;
    userId?: string;
    isActive?: boolean;
    title?: string;
}

@Component({
    selector: 'training-list-modal',
    templateUrl: './trainingListModal.component.html',
    styleUrls: ['./trainingListModal.component.scss']
})
export class TrainingListModalComponent implements OnInit {
    trainings: Training[] = [];
    loading: boolean = true;
    title: string = 'Training List';

    constructor(
        public dialogRef: MatDialogRef<TrainingListModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TrainingListModalData,
        private trainingService: TrainingService,
        private alertService: AlertService,
        private router: Router,
        private dialog: MatDialog
    ) {
        if (data.title) {
            this.title = data.title;
        }
    }

    ngOnInit(): void {
        this.loadTrainings();
    }

    loadTrainings(): void {
        this.loading = true;

        const params: any = {
            limit: 50,
            sortCol: 'createdAt',
            sortDir: 'desc'
        };

        if (this.data.resourceId) {
            params.resourceId = this.data.resourceId;
        }

        if (this.data.userId) {
            params.userId = this.data.userId;
        }

        if (this.data.isActive !== undefined) {
            params.isActive = this.data.isActive;
        }

        this.trainingService.getTrainings(params).pipe(first()).subscribe(
            (res: TrainingItems) => {
                this.trainings = res.items;
                this.loading = false;
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            }
        );
    }

    goToDetails(training: Training): void {
        this.dialogRef.close();
        this.router.navigate(['/training-details', training.id]);
    }

    openDetailsModal(training: Training): void {
        const dialogRef = this.dialog.open(TrainingDetailsModalComponent, {
            width: '90vw',
            maxWidth: '1200px',
            height: '90vh',
            data: { trainingId: training.id }
        });
    }

    close(): void {
        this.dialogRef.close();
    }
}